module.exports = __webpack_public_path__ + "img/radiobox-marked.3292aed.svg";